import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onBeforeUnmount, onMounted } from "vue";
import { storeToRefs } from "pinia";
import ErrorAlertComponent from "@/components/ErrorAlertComponent.vue";
import NotificationToast from "@/components/NotificationToast.vue";
import TermsComponent from "@/components/TermsComponent.vue";
import { pusherService } from "@/di/pusher";
import { syncSession } from "@/di/useCases";
import { useOffcanvasStore } from "@/store/useOffcanvasStore";
import { useSessionStore } from "@/store/useSessionStore";
import { toggleOffcanvas } from "@/utils/Helper";
import OffcanvasViews from "@/views/OffcanvasViews/OffcanvasViews.vue";
import { startFirebase } from "./firebaseinit";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

document.title = process.env.VUE_APP_APP_NAME as string;
const { session } = storeToRefs(useSessionStore());

onMounted(() => {
  // reabre o painel lateral que estava aberto antes do reload
  if (useOffcanvasStore().config?.path) toggleOffcanvas("offcanvas_views");
  if (useSessionStore().session) syncSession.execute();
  pusherService.connect();
  startFirebase();
});
onBeforeUnmount(() => pusherService.disconnect());

return (_ctx: any,_cache: any) => {
  const _component_ConfirmationAlert = _resolveComponent("ConfirmationAlert")!
  const _component_PamiaWidget = _resolveComponent("PamiaWidget")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmationAlert),
    _createVNode(NotificationToast),
    _createVNode(ErrorAlertComponent),
    _createVNode(TermsComponent),
    _createVNode(OffcanvasViews),
    (_unref(session))
      ? (_openBlock(), _createBlock(_component_PamiaWidget, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}
}

})